module.exports = __webpack_public_path__ + "png/wheel-numbers.png?9cb63be3fcd06ea756d066c7b577f4bf";